const measurements = {
	cmToPx: 300 / 2.54,
	pxToCm: 2.54 / 300//2.5397999999999999 / 300
}
export default measurements